export const PRESET_TRIGGER_DELAYS_UNITS = [
    { value: 'minutes', label: 'Minutes', multiplyBy: 1 },
    { value: 'hours', label: 'Hours', multiplyBy: 60 },
    { value: 'days', label: 'Days', multiplyBy: 24*60 },
    { value: 'weeks', label: 'Weeks', multiplyBy: 24*60*7 },
    { value: 'months', label: 'Months', multiplyBy: 24*60*30 },
];